import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import {
  APP_INITIALIZER,
  CUSTOM_ELEMENTS_SCHEMA,
  NO_ERRORS_SCHEMA,
  NgModule,
} from "@angular/core";
import { FormsModule } from "@angular/forms";
import { BrowserModule, HammerModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ServiceWorkerModule } from "@angular/service-worker";
import { NgbModule, NgbNavModule } from "@ng-bootstrap/ng-bootstrap";
import { MessageService } from "primeng/api";
import { environment } from "src/environments/environment";
import { AnnotationModule } from "./annotation/annotation.module";
import { AppConfigService } from "./app-config.service";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { CoreModule } from "./core/core.module";
import { GoogleAnalyticsService } from "./google-analytics/google-analytics.service";
import { CheckForUpdateService } from "./shared/check-for-update.service";
import { LoaderComponent } from "./shared/loader/loader.component";
import { PromptUpdateService } from "./shared/prompt-update.service";
import { SharedModule } from "./shared/shared.module";
import {
  MsalInterceptor,
  MsalModule,
  MsalRedirectComponent,
  MsalService,
} from "@azure/msal-angular";

const appInitializerFn = (appConfig: AppConfigService) => {
  return () => {
    return appConfig.loadAppConfig();
  };
};

@NgModule({
  declarations: [AppComponent, LoaderComponent],
  imports: [
    BrowserModule,
    HammerModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    MsalModule,
    NgbModule,
    NgbNavModule,
    CoreModule,
    AnnotationModule,
    SharedModule,
    ServiceWorkerModule.register("ngsw-worker.js", {
      enabled: environment.production,
      registrationStrategy: "registerImmediately",
    }),
    BrowserAnimationsModule,
  ],
  providers: [
    MessageService,
    AppConfigService,
    CheckForUpdateService,
    PromptUpdateService,
    GoogleAnalyticsService,
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFn,
      multi: true,
      deps: [AppConfigService],
    },
    MsalService,
  ],
  bootstrap: [AppComponent, MsalRedirectComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class AppModule {}
